import { HostService } from '../host/host.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class MenuService {
  host:string;
  public bestSalesOffers: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  constructor(
    private hostService:HostService,
    private http:HttpClient,
  ) {
    this.host=this.hostService.host;
  }


  getMenusOfCategory(idCat,idOrderType,orderProg){
    return this.http.get(this.host+'menus/carte/category/'+idCat+'/orderType/'+idOrderType,{params:{orderProg}});  
  }

  getMenuCompositions(idMenu,orderType,orderProg){
    return this.http.get(this.hostService.host+'menus2/'+idMenu+'/orderType/'+orderType+'/compositions',{params:{orderProg}});
  }

  getMenuAdditionalOptionss(idMenu){
    return this.http.get(this.hostService.host+'menus2/'+idMenu+'/additionalOptions');
  }

  getOffers(idOrderType,orderProg){
    return this.http.get(this.host+'bestoffers/orderType/'+idOrderType,{params:{orderProg}}); 
  }

  getActiveMenuBySearch(key, orderType,orderProg) {
    return this.http.get(this.hostService.host + 'menus/active/orderType/' + orderType + '/key/' + key,{params:{orderProg}});
  }
  
}
